import { render } from "./IconRequestsSvg.vue?vue&type=template&id=2431c6c4"
const script = {}

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__